export default __webpack_public_path__ + "static/media/slide-4.b8d20b41.webp";